module.exports = __webpack_public_path__ + "media/images/pla/plagirl-05a56071edd71c503cfb5cd319bec8ec.jpg";